module.exports = __webpack_public_path__ + "img/autocisterna.3b6d04a1.png";